/* NB-013 — winner, returning users only */
(function () {
  var ROOT_SEL = '[data-nb013-root]';
  var ACTIVATION_CLASS = 'nb013-ab-var-1';
  var placed = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function findControlHeader() {
    var title =
      document.querySelector('.product-info-section .product-meta .product-title') ||
      document.querySelector('.product-meta .product-title') ||
      document.querySelector('.product-title');

    if (!title) return null;
    return title.parentElement || null;
  }

  function findMeta(root) {
    return (
      (root && root.closest('.product-meta')) ||
      document.querySelector('.product-info-section .product-meta') ||
      document.querySelector('.product-meta')
    );
  }

  function findMobileGallery(meta) {
    if (!meta) return null;
    return (
      meta.querySelector('.product-gallery-container-mobile') ||
      meta.querySelector('.product-gallery-container-mobile.md\\:hidden')
    );
  }

  /* BUG-002 + BUG-004: gallery first in meta, no leading gap */
  function placeMobileGallery(root) {
    var meta = findMeta(root);
    if (!meta || !root) return;

    var gallery = findMobileGallery(meta);
    if (!gallery) return;

    var first = meta.firstElementChild;
    if (first !== gallery) {
      meta.insertBefore(gallery, first);
    }

    gallery.style.marginTop = '0';
    gallery.style.paddingTop = '0';
  }

  function placeVariant(root) {
    if (!root) return false;

    var header = findControlHeader();
    if (!header) return false;

    var parent = header.parentNode;
    if (!parent) return false;

    header.setAttribute('data-nb013-control', 'true');

    if (!(root.parentNode === parent && root.nextElementSibling === header)) {
      parent.insertBefore(root, header);
    }

    root.classList.add('is-placed');
    placeMobileGallery(root);
    placed = true;
    return true;
  }

  function shouldActivate() {
    var html = document.documentElement;
    return (
      html.classList.contains(ACTIVATION_CLASS) ||
      html.classList.contains('nb-experts-trust-returning')
    );
  }

  function activate() {
    if (!shouldActivate()) return false;

    document.documentElement.classList.add(ACTIVATION_CLASS);

    var root = document.querySelector(ROOT_SEL);
    if (!root) return false;

    return placeVariant(root);
  }

  ready(function () {
    activate();

    var observer = new MutationObserver(function () {
      if (!shouldActivate()) return;
      if (placed && document.querySelector(ROOT_SEL + '.is-placed')) {
        placeMobileGallery(document.querySelector(ROOT_SEL));
        return;
      }
      placed = false;
      activate();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  });

  window.nb013ActivateAtf = function () {
    document.documentElement.classList.add(ACTIVATION_CLASS);
    placed = false;
    return activate();
  };
})();
